import React from 'react';
import './Hero.css';
import {
    Card,
    CardBody,
    CardFooter,
    Typography,
  } from "@material-tailwind/react";

const BigCard = ({title,description,icon}) => {

    return (
        <section className="relative ">
            <div className="relative">
                <Card className=" shadow-2xl font-poppins bg-white bg-opacity-80 xl:backdrop-blur-sm">
                    <CardBody className="flex flex-col items-start">
                        <div className="mb-4">
                           {icon} 
                           </div>
                        <Typography variant="h5" color="blue-gray" className="mb-2 font-poppins w-full">
                            {title} 
                        </Typography>
                        <Typography className="w-full h-1/3 lg:h-40 xl:h-32 font-poppins "> {description} </Typography>
                    </CardBody>
                    <CardFooter className="pt-0">
                    </CardFooter>
                </Card>
            </div>
        </section>

    );
};

export default BigCard;
